import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ciw03kwuu3: FaireBrandEntity = {
  token: "b_ciw03kwuu3",
  type: "brand",
  name: "Catherine Tough (US Duties Paid)",
  avatarUrl:
    "https://cdn.faire.com/fastly/dabe2922914174b829cd9d1f882b199c09e3557b5c66047d92788acd3f60a018.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/6a7c4df89e827f0e89302651ff4591e9806524a1c46e72e79b3b2d246efc0886.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/dabe2922914174b829cd9d1f882b199c09e3557b5c66047d92788acd3f60a018.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6a7c4df89e827f0e89302651ff4591e9806524a1c46e72e79b3b2d246efc0886.jpeg",
  location: "LONDON, GBR",
  minimumOrderDollars: 131,
  rating: 4.9,
  reviewCount: 77,
  isTopShop: true,
  isInsider: false,
  description:
    "Cosy winter woollies and seasonal gifts - in stock and ready to dispatch the next day.\n\nCatherine Tough graduated from the Royal College of Art, London in 1999 with the vision of turning heritage craft into playful, modern accessories that are a pleasure to wear and use. Inspired by nature, travel and colour, she and her team continue to make products to cherish and a joy to gift to others.  \n\nHer best-selling range includes cosy lambswool socks, expertly knitted hats, scarves and gloves, hot water bottle covers and lavender-filled creatures!\n\nThe collection is designed at Catherine's London studio and is produced there or in Scotland & Portugal.",
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:57:48.836Z",
    importedBy: "entity-db-cli",
  },
};
